import React from 'react';
import PropTypes from 'prop-types';
import { MoonLoader } from 'react-spinners';

const Spinner = ({
  processingSubmit
}) => (
  <div data-test-id="loading-spinner" className="modal-spinner form-submitted">
    <div className='modal-spinner-inner'>
      <div className='modal-spinner-box'>
        <MoonLoader
          sizeUnit='px'
          size={150}
          color='#1c5291'
          loading={processingSubmit}
        />
      </div>
    </div>
  </div>
);

Spinner.propTypes = {
  processingSubmit: PropTypes.bool,
};

export default Spinner;

